import React, { useEffect, useRef, useState } from 'react';
import './LessonVideo.css';

let apiPromise = null;
function loadYouTubeApi() {
  if (window.YT && window.YT.Player) return Promise.resolve();
  if (apiPromise) return apiPromise;
  apiPromise = new Promise((resolve) => {
    const prev = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
      if (typeof prev === 'function') { try { prev(); } catch (_) {} }
      resolve();
    };
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    tag.async = true;
    document.body.appendChild(tag);
  });
  return apiPromise;
}

export default function LessonVideo({ videoId, onEnd, onClose, downloadUrl }) {
  const containerRef = useRef(null);
  const playerRef = useRef(null);
  const [ready, setReady] = useState(false);
  const [error, setError] = useState('');
  const [ended, setEnded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    loadYouTubeApi().then(() => {
      if (cancelled || !containerRef.current) return;
      try {
        playerRef.current = new window.YT.Player(containerRef.current, {
          videoId,
          playerVars: { rel: 0, modestbranding: 1, playsinline: 1 },
          events: {
            onReady: () => setReady(true),
            onStateChange: (event) => {
              if (event.data === window.YT.PlayerState.ENDED) {
                setEnded(true);
                if (onEnd) onEnd();
              }
            },
            onError: () => setError('Не удалось загрузить видео.'),
          },
        });
      } catch (e) {
        setError('Не удалось запустить плеер.');
      }
    });
    return () => {
      cancelled = true;
      if (playerRef.current && playerRef.current.destroy) {
        try { playerRef.current.destroy(); } catch (_) {}
      }
    };
  }, [videoId]);

  return (
    <div className="lesson-video-overlay" role="dialog" aria-modal="true">
      <div className="lesson-video-card">
        <button type="button" className="lesson-video-close" onClick={onClose} aria-label="Закрыть">×</button>
        <div className="lesson-video-frame">
          <div ref={containerRef} />
          {!ready && !error && <div className="lesson-video-loading">Загрузка видео…</div>}
          {error && <div className="lesson-video-error">{error}</div>}
        </div>
        {downloadUrl && ended && (
          <a className="lesson-video-download" href={downloadUrl} download target="_blank" rel="noopener noreferrer">
            📄 Скачать текстовый файл с промтом
          </a>
        )}
        <button type="button" className="lesson-video-later" onClick={onClose}>{ended ? "Закрыть" : "Позже"}</button>
      </div>
    </div>
  );
}
